import React from 'react';
import { ShieldCheck, Lock, CreditCard, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-20 bg-surface border-t border-gray-200" data-id="element-90">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center" data-id="element-91">
        <div className="max-w-md mx-auto mb-12" data-id="element-92">
          <div className="bg-white rounded-2xl p-6 border-2 border-primary shadow-lg text-left relative" data-id="element-93">
            <div className="absolute -top-3 right-4 bg-gradient-to-r from-primary to-secondary text-white text-xs font-bold px-2 py-1 rounded-full" data-id="element-94">
              OFERTA DE LANZAMIENTO
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-1" data-id="element-95">
              📘 MEGAPACK OPERATIVO AIRBNB MANAGER
            </h3>
            <p className="text-sm text-gray-500 mb-4" data-id="element-96">6 Tomos + 6 Bonos</p>
            <div className="flex items-end gap-2 mb-4" data-id="element-97">
              <span className="text-gray-400 line-through text-sm" data-id="element-98">
                $69.000
              </span>
              <span className="text-2xl font-bold text-gray-900" data-id="element-99">
                $19.990 ARS
              </span>
            </div>
            <a href="https://www.iterapro.shop/checkouts/cn/hWNBlFOOMww9wDpt5gWKQ5lS/es-ar?_r=AQABqj-sTAqS3u_oZF2xIAQCkLeqZFjYy96SSuUsFF8v3MM&cart_link_id=0TVX6ial&preview_theme_id=163813163097" target="_blank" rel="noopener noreferrer" className="w-full py-3 px-4 bg-gradient-to-r from-primary to-secondary hover:shadow-lg hover:shadow-primary/30 text-white font-bold rounded-xl transition-all text-sm block text-center" data-id="element-100">
              🔴 QUIERO MI MEGAPACK AHORA
            </a>
          </div>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8 text-sm text-gray-600 font-medium" data-id="element-101">
          <div className="flex items-center gap-1.5" data-id="element-102">
            <Lock className="w-4 h-4 text-gray-400" data-id="element-103" /> Pago 100% seguro
          </div>
          <div className="flex items-center gap-1.5" data-id="element-104">
            <Zap className="w-4 h-4 text-yellow-500" data-id="element-105" /> Acceso en 5 minutos
          </div>
          <div className="flex items-center gap-1.5" data-id="element-106">
            <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-107" /> Garantía 7 días
          </div>
          <div className="flex items-center gap-1.5" data-id="element-108">
            <CreditCard className="w-4 h-4 text-blue-500" data-id="element-109" /> Mercado Pago |
            Tarjeta | Transferencia
          </div>
        </div>
      </div>
    </section>;
}